import { Component } from '@angular/core';
import type { ContactResponseStatus } from '@core/api/workspace/models/contactResponseStatus';
import { ContactResponseStatus as ContactStatus } from '@core/api/workspace/models/contactResponseStatus';

const STATUS_LABELS: Record<ContactResponseStatus, string> = {
  [ContactStatus.ACTIVE]: 'Active',
  [ContactStatus.INACTIVE]: 'Inactive',
  [ContactStatus.SUSPENDED]: 'Suspended',
};

const STATUS_CHIP_CLASS: Record<ContactResponseStatus, string> = {
  [ContactStatus.ACTIVE]: 'bg-success-100 text-success-700',
  [ContactStatus.INACTIVE]: 'bg-neutral-100 text-neutral-600',
  [ContactStatus.SUSPENDED]: 'bg-warning-100 text-warning-700',
};

const STATUS_DOT_CLASS: Record<ContactResponseStatus, string> = {
  [ContactStatus.ACTIVE]: 'bg-success-700',
  [ContactStatus.INACTIVE]: 'bg-neutral-500',
  [ContactStatus.SUSPENDED]: 'bg-warning-700',
};

@Component({
  selector: 'app-contact-status-cell',
  standalone: true,
  template: `
    <span
      [class]="
        'inline-flex items-center gap-2 rounded-full px-2.5 py-1.5 ' + chipClass
      ">
      <span class="h-1.5 w-1.5 shrink-0 rounded-full" [class]="dotClass"></span>
      <span class="text-body2 text-nowrap">{{ label }}</span>
    </span>
  `,
})
export class ContactStatusCellComponent {
  /** Set by NGL DynamicRenderer. */
  rowData!: { status?: ContactResponseStatus };

  get status(): ContactResponseStatus | undefined {
    return this.rowData?.status;
  }

  get label(): string {
    const status = this.status;
    if (!status) {
      return '';
    }
    return STATUS_LABELS[status] ?? status;
  }

  get chipClass(): string {
    const status = this.status;
    if (!status) {
      return 'bg-neutral-100 text-neutral-600';
    }
    return STATUS_CHIP_CLASS[status] ?? 'bg-neutral-100 text-neutral-600';
  }

  get dotClass(): string {
    const status = this.status;
    if (!status) {
      return 'bg-neutral-500';
    }
    return STATUS_DOT_CLASS[status] ?? 'bg-neutral-500';
  }
}
